export default "__VITE_ASSET__BOx6aVVe__"